import RegisteredEmailDomainInputContainer from './RegisteredEmailDomainInputContainer';

export default RegisteredEmailDomainInputContainer;
